import React, { CSSProperties } from 'react'

export const setStyle = (style: string) => (
    <style
        dangerouslySetInnerHTML={{
            __html: style,
        }}
    />
)

export const buildStyles = (style: CSSProperties) => `{
    ${style.backgroundColor ? `background-color: ${style.backgroundColor};` : ''}
    ${style.backgroundImage ? `background-image: ${style.backgroundImage};` : ''}
    ${style.color ? `color: ${style.color};` : ''}
    ${style.fontSize ? `font-size: ${style.fontSize};` : ''}
    ${style.fontStyle ? `font-style: ${style.fontStyle};` : ''}
    ${style.fontWeight ? `font-weight: ${style.fontWeight};` : ''}
}`
